import { createAsyncThunk } from '@reduxjs/toolkit';

import { getBusinessTypes } from '../../../service/graphql/account/getBusinessTypes';
import { AsyncThunkConfig } from '../../store';

export const getBusinessTypesThunk = createAsyncThunk<string[], void, AsyncThunkConfig>(
  'userAccount/getBusinessTypes',
  async (_, { getState }) => {
    const { launchDarkly } = getState();
    return getBusinessTypes(launchDarkly.data);
  },
);
